import React from 'react';

import Switch from 'components/shared/Switch/Switch';

const ValueCellRenderer = ({ value, data }) => {
  if (data?.type === 'boolean') {
    return (
      <div className="flex h-full items-center">
        <Switch checked={value} size="small" data-qa={`toggle-${data.key}`} />
      </div>
    );
  }

  if (data?.type === 'string') {
    return (
      <div className="flex h-full max-w-[200px] items-center break-all text-sm text-neutral-800">
        {value || <span className="italic text-neutral-400">N/A</span>}
      </div>
    );
  }

  return null;
};

export default ValueCellRenderer;
